<template lang="pug">
  .avatar(:style='getWidth')
    img.img(:src='image || defaultProfileImage')
</template>

<script>
import defaultProfileImage from '@/assets/empty_profile.svg'

export default {
  props: {
    image: { type: String },
    width: { tpye: String }
  },
  data() {
    return {
      defaultProfileImage
    }
  },
  computed: {
    getWidth() {
      return {
        '--avatar-width': this.width
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.avatar{
  --avatar-width: 25px;
  border-radius: 50%;
  overflow: hidden;
  width: var(--avatar-width);
  height: var(--avatar-width);
  .img{
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
}
</style>
